import { Link } from 'react-router-dom';

import * as styles from './styles';

import { Location } from '@cobliteam/common-types';

import { Button } from '@cobliteam/ui/components';

import { PlaceholderNoAccess } from '../icons';

import { Placeholder } from '../Placeholder';
import { Heading1, InputText } from '../typography';

interface AccessDeniedPanelProps {
  pageDescription: string;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
const AccessDeniedPanel = ({ pageDescription }: AccessDeniedPanelProps) => {
  const openPermissionsHelpPage = () => {
    const a = document.createElement('a');
    a.href = 'https://suporte.cobli.co/quais-permiss%C3%B5es-cada-fun%C3%A7%C3%A3o-tem-acesso';
    a.target = '_blank';
    a.click();
  };

  return (
    <div className={styles.drawer}>
      <Placeholder className={styles.placeholder} text='' Icon={PlaceholderNoAccess} />
      <div className={styles.description}>
        <Heading1>Opss... Parece que você está sem acesso.</Heading1>
        <InputText>
          Você está sem permissão para {pageDescription}.
          <br />
          Fale com o administrador da sua frota para conseguir acesso.
        </InputText>
        <br />
        <Link to={Location.HOME}>
          <Button>Voltar para o início</Button>
        </Link>
        <Button variant='text' color='secondary' onClick={openPermissionsHelpPage}>
          Saiba mais sobre permissões
        </Button>
      </div>
    </div>
  );
};

export default AccessDeniedPanel;
